import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPennantPillFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 13,
	viewBox: "0 0 10 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H8.5C9.32843 0 10 0.671573 10 1.5V10.8252C10 11.7697 8.95922 12.344 8.16013 11.8403L5.79983 10.3526C5.3111 10.0446 4.6889 10.0446 4.20017 10.3526L1.83986 11.8403C1.04078 12.344 0 11.7697 0 10.8252L0 1.5Z",
		fill: "currentColor"
	})
});
export { SvgIconPennantPillFilled as ReactComponent };
